
import Vue from 'vue'

import App from './App.vue'
import router from './router.js'
import './moment'
import './vee-validate'
import './toast'
import "./axios";
// import './event_bus'


global.jQuery = require('jquery');
var $ = global.jQuery;
window.$ = $;

import './../node_modules/slick-carousel/slick/slick.css';
import '../public/css/style.scss';
import 'promise-polyfill/src/polyfill';

new Vue({
	router:router,
	render: h => h(App),
}).$mount('#app')
